import { Divider as NatDsDivider } from '@naturacosmeticos/natds-web'

export const Divider = NatDsDivider
